import PropTypes from 'prop-types'
import React from 'react'
import { RadioGroup as ReactRadioGroup } from 'react-radio-group'
import { concatClasses } from '../../utils/fns'

const propTypes = {
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
}

const getClassName = (classes = '') => concatClasses('radioGroup', classes)

export const RadioGroup = ({ children, onChange, className, ...props }) => {
  const handleChange = (value) => {
    onChange({ target: { name: props.name, value } })
  }

  return (
    <ReactRadioGroup className={getClassName(className)} onChange={handleChange} {...props}>
      {children}
    </ReactRadioGroup>
  )
}

RadioGroup.propTypes = propTypes
